import { Search } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { SearchModal } from 'screens/blaze/Search/SearchModal/SearchModal'
import { AcademyMobileTopBar } from 'blaze-components/TopBar/MobileTopBar/AcademyMobileTopBar'
import {
  ACADEMY_PATH,
  ALL_FILES_PATH,
  ANALYTICS_PATH,
  BLAZE_HOME_PATH,
  BRAND_KIT_PATH,
  BRAND_KITS_PATH,
  CAMPAIGNS_PATH,
  FAVORITES_PATH,
  FOLDER_PATH,
  NATIVE_WEBVIEW_BRAND_KIT_PATH,
  SCHEDULED_POSTS_PATH,
  TEMPLATES_PATH,
  TODOS_PATH,
  UPLOADS_PATH,
  WIZARD_PATH,
} from 'paths'
import { Switch } from 'react-router-dom'
import { SentryRoute } from 'components/SentryRoute'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { FinderMobileTopBar } from './FinderMobileTopBar'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { BaseMobileTopBar } from './BaseMobileTopBar'
import { AllFilesMobileTopBar } from './AllFilesMobileTopBar'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { AnalyticsMobileTopBar } from './AnalyticsMobileTopBar'
import { TemplatesMobileTopBar } from './TemplatesMobileTopBar'
import { BrandKitMobileTopBar } from './BrandKitMobileTopBar'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { BrandKitsMobileTopBar } from 'blaze-components/TopBar/MobileTopBar/BrandKitsMobileTopBar'

export const MobileTopBar = () => {
  const { openModal } = useModals()
  const { currentFolder } = useCurrentFolderStore()
  const theme = useHeaderTheme()

  return (
    <Switch>
      <SentryRoute path={FOLDER_PATH}>{currentFolder && <FinderMobileTopBar folder={currentFolder} />}</SentryRoute>

      <SentryRoute path={ALL_FILES_PATH}>
        <AllFilesMobileTopBar />
      </SentryRoute>

      <SentryRoute path={SCHEDULED_POSTS_PATH}>
        <BaseMobileTopBar title="Scheduled Posts" />
      </SentryRoute>

      <SentryRoute path={TODOS_PATH}>
        <BaseMobileTopBar title="Reviews & Approvals" />
      </SentryRoute>

      <SentryRoute path={BRAND_KIT_PATH}>
        <BrandKitMobileTopBar />
      </SentryRoute>

      <SentryRoute path={BRAND_KITS_PATH}>
        <BrandKitsMobileTopBar />
      </SentryRoute>

      <SentryRoute path={ACADEMY_PATH}>
        <AcademyMobileTopBar />
      </SentryRoute>

      <SentryRoute path={FAVORITES_PATH}>
        <BaseMobileTopBar title="Favorites" />
      </SentryRoute>
      <SentryRoute path={ANALYTICS_PATH}>
        <AnalyticsMobileTopBar />
      </SentryRoute>

      <SentryRoute path={TEMPLATES_PATH}>
        <TemplatesMobileTopBar title="Templates" />
      </SentryRoute>

      <SentryRoute path={UPLOADS_PATH}>
        <BaseMobileTopBar title="Uploads" />
      </SentryRoute>

      <SentryRoute path={BLAZE_HOME_PATH}>{null}</SentryRoute>
      <SentryRoute path={CAMPAIGNS_PATH}>{null}</SentryRoute>
      <SentryRoute path={WIZARD_PATH}>{null}</SentryRoute>
      <SentryRoute path={NATIVE_WEBVIEW_BRAND_KIT_PATH}>{null}</SentryRoute>

      <SentryRoute>
        <MobileTopBarContainer.Root data-theme={theme}>
          <MobileTopBarContainer.Left>
            <UnlockButton />
            <Button icon={Search} onPress={() => openModal(SearchModal)} />
          </MobileTopBarContainer.Left>
        </MobileTopBarContainer.Root>
      </SentryRoute>
    </Switch>
  )
}
